import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import HotelContextProvider from './context/HotelContext';
import LanguageContextProvider from './context/LanguageContext';
import { BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter>
        <HotelContextProvider>
            <LanguageContextProvider>
                <App />
            </LanguageContextProvider>
        </HotelContextProvider>
    </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
